import React, { useState, useEffect } from "react";
import Header from "../../components/HomePage/header";
import AiPricing from "./AiSurveyPricing";
import SurveySection from "./SurveySection";

const SurveyPage = () => {
  const [surveyData, setSurveyData] = useState({ data: [] });
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [surveyResult, setSurveyResult] = useState("");
  const [priceData, setPriceData] = useState({});


  useEffect(() => {
    const fetchSurveyData = async () => {
      try {
        const response = await fetch("/api/surveydata", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setSurveyData({ data });
        } else {
          console.error("Failed to fetch SurveyData. Status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching SurveyData data:", error);
      }
    };

    fetchSurveyData();
  }, []);

  const handleOptionChange = (option) => {
    setSelectedOptions({
      ...selectedOptions,
      [currentStep]: option,
    });
  };

  const handleNextStep = () => {
    if (currentStep < surveyData.data.length) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    // Simulating API request delay
    setTimeout(() => {
      // Counters for each proficiency level
      let beginnerCount = 0;
      let intermediateCount = 0;
      let advancedCount = 0;

      // Iterate through selected options
      Object.values(selectedOptions).forEach((selectedOption) => {
        // Log the selected option
        console.log(`Selected Option: ${selectedOption}`);

        // Iterate through survey data questions
        surveyData.data.forEach((question) => {
          // Check if the insight property exists in the question object
          if (question.insight) {
            // Iterate through the insights for the current question
            question.insight.forEach((insight, insightIndex) => {
              // Construct regular expressions for each proficiency level
              const selectedLetter = selectedOption.charAt(0).toUpperCase();
              const regexBeginner = new RegExp(`\\b${selectedLetter}\\b`, "i");
              const regexIntermediate = new RegExp(`\\b${selectedLetter}\\b`, "i");
              const regexAdvanced = new RegExp(`\\b${selectedLetter}\\b`, "i");

              // Check if the selected option matches any proficiency level
              if (regexBeginner.test(insight.beginner)) {
                console.log(`Matched Insight for Question ${insightIndex + 1} (Beginner):`, insight.beginner);
                beginnerCount++;
              } else if (regexIntermediate.test(insight.intermediate)) {
                console.log(`Matched Insight for Question ${insightIndex + 1} (Intermediate):`, insight.intermediate);
                intermediateCount++;
              } else if (regexAdvanced.test(insight.advanced)) {
                console.log(`Matched Insight for Question ${insightIndex + 1} (Advanced):`, insight.advanced);
                advancedCount++;
              }
            });
          } else {
            console.log("Insight property not found in the question object.");
          }
        });
      });

      // Calculate total count of options
      const totalCount = beginnerCount + intermediateCount + advancedCount;

      // Calculate percentage of each proficiency level
      const beginnerPercentage = (beginnerCount / totalCount) * 100;
      const intermediatePercentage = (intermediateCount / totalCount) * 100;
      const advancedPercentage = (advancedCount / totalCount) * 100;

      // Determine the overall proficiency level based on the highest percentage
      let proficiencyLevel;
      if (beginnerPercentage >= intermediatePercentage && beginnerPercentage >= advancedPercentage) {
        proficiencyLevel = 'Beginner';
      } else if (intermediatePercentage >= beginnerPercentage && intermediatePercentage >= advancedPercentage) {
        proficiencyLevel = 'Intermediate';
      } else {
        proficiencyLevel = 'Advanced';
      }

      // Set the survey result based on the determined proficiency level
      setSurveyResult(proficiencyLevel);
         // Set the price data based on the proficiency level
         let priceObj = {};
         switch (proficiencyLevel) {
           case "Beginner":
             priceObj = { price: 100, duration: 6, level: "Beginner" };
             break;
           case "Intermediate":
             priceObj = { price: 70, duration: 4 , level: "Intermediate" };
             break;
           case "Advanced":
             priceObj = { price: 50, duration: 3, level: "Advanced" };
             break;
           default:
             break;
         }
         setPriceData(priceObj);
   
      setIsLoading(false);
      setShowPricing(true);
    }, 2000);
  };

  console.log("Survey Result:", surveyResult);
  console.log("Price Result:", priceData);


  return (
    <div>
      <Header />
      {!showPricing && (
        <SurveySection
          currentStep={currentStep}
          surveyData={surveyData}
          selectedOptions={selectedOptions}
          isLoading={isLoading}
          handleOptionChange={handleOptionChange}
          handleNextStep={handleNextStep}
          handlePreviousStep={handlePreviousStep}
          handleSubmit={handleSubmit}
        />
      )}
      {showPricing && <AiPricing priceData={priceData} />}
    </div>
  );
};

export default SurveyPage;
